// extracted by mini-css-extract-plugin
export default {"root":"_6MqAEHFzjZvRc7kH51a7","logo":"Q1dTwMBL4l0ymU3N39YY"};